// src/utils/jobLines.js — GENERATED from functions/utils/jobLines.js. DO NOT EDIT BY HAND.
// Regenerate: node functions/scripts/buildJobLinesCopies.js   (nolines-59a4771f)
// src/utils/jobLines.test.js fails if this file is not exactly what the generator writes.
// What this does and why: see the header of functions/utils/jobLines.js.

/* eslint-disable */

// JOBLINES-BODY-START
var NO_LINES_INVOICE_MESSAGE = 'Add at least one line item before creating an invoice.';

function isLineObject(line) {
  return !!line && typeof line === 'object' && !Array.isArray(line);
}

function hasText(value) {
  return value !== undefined && value !== null && String(value).trim() !== '';
}

function isEmptyNumber(value, allowed) {
  if (value === undefined || value === null || String(value).trim() === '') return true;
  var n = Number(value);
  return allowed.indexOf(n) !== -1;
}

// Nothing to bill: no name, service or description; price 0/empty; quantity 1, 0 or empty.
function hasNoContent(line) {
  if (!isLineObject(line)) return false;
  if (hasText(line.name) || hasText(line.serviceId) || hasText(line.description)) return false;
  return isEmptyNumber(line.price, [0]) && isEmptyNumber(line.quantity, [0, 1]);
}

// An untouched row (dropped on save): nothing to bill AND no crew picked.
function isBlankLine(line) {
  return hasNoContent(line) && !hasText(line.crewGroupId);
}

// The rows to save: blank rows dropped, every other row kept exactly as it was (same objects, same order).
function dropBlankLines(lines) {
  if (!Array.isArray(lines)) return lines;
  return lines.filter(function (line) { return !isBlankLine(line); });
}

// True when there is at least one line with something to bill (a crew alone is not a line item).
function hasInvoiceableLines(lines) {
  if (!Array.isArray(lines)) return false;
  return lines.some(function (line) { return isLineObject(line) && !hasNoContent(line); });
}

// The refusal for one job in a batch, naming the job: "Job #1234: Add at least one line item ..."
function noLinesInvoiceReason(jobNumber) {
  return hasText(jobNumber) ? 'Job #' + String(jobNumber).trim() + ': ' + NO_LINES_INVOICE_MESSAGE : NO_LINES_INVOICE_MESSAGE;
}
// JOBLINES-BODY-END

export { NO_LINES_INVOICE_MESSAGE, isBlankLine, dropBlankLines, hasInvoiceableLines, noLinesInvoiceReason };
